.textarea {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: 0.625rem;
  overflow: hidden;
  font-weight: 300;
  font-size: 1.125rem;
  line-height: 1.5625rem;
  cursor: text;
  min-height: 6rem;
  background-color: var(--neutral);
  box-shadow: 0 0 0.125rem 0 rgba(28, 30, 29, 0.33);

  @media (min-width: 769px) {
    font-size: 1rem;
  }

  &:hover {
    &:not(.flat),
    &:not(.invalid),
    &:not(.focused),
    &:not(.disabled),
    &:not(.readOnly) {
      border: none;
      box-shadow: 0 0 0.125rem 0 rgba(28, 30, 29, 0.55);
    }
  }

  &.disabled,
  &.readOnly {
    background-color: var(--neutral-50);
    box-shadow: 0 0 0 0.0625rem var(--neutral-200);
  }

  &.invalid {
    border: none;
    box-shadow: 0 0 0 0.0625rem var(--danger);
  }

  &.focused {
    &:not(.flat),
    &:not(.invalid),
    &:not(.disabled),
    &:not(.readOnly) {
      border: none;
      box-shadow: 0 0 0 0.0625rem var(--primary-600);
    }
  }

  &.disabled {
    cursor: no-drop;
  }

  .field {
    width: 100%;
    height: 100%;
    min-height: inherit;
    padding-top: 0.5625rem;
    padding-right: 0.6875rem;
    padding-bottom: 0.5625rem;
    padding-left: 0.6875rem;
    border: none;
    border-radius: 0;
    outline: none;
    color: var(--neutral-600);
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    cursor: inherit;
    background-color: transparent;
    box-shadow: none;

    @media (min-width: 400px) {
      padding-top: 0.625rem;
      padding-right: 0.75rem;
      padding-bottom: 0.625rem;
      padding-left: 0.75rem;
    }

    &[type='number'] {
      appearance: textfield;
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
    }

    &::placeholder {
      color: var(--neutral-500);
      user-select: none;
      pointer-events: none;
    }

    &:focus,
    &:active {
      &::placeholder {
        opacity: 0;
      }
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      margin: 0;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
    }
  }
}
